module.exports = __webpack_public_path__ + "static/media/designer-news.7c534f8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/site-menu/assets/designer-news.svg
// module id = 17
// module chunks = 0